<template>
  <div class="warehouseProfitAccounting">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="$t.warehouse.inputNumberSearch"
          >
            <template #action>
              <div @click="getList">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
      </van-row>
    </div>

    <van-form label-width="120px" v-if="isLoaded">
      <div class="title">{{ $t.meta.basicTitle }}</div>

      <van-field
        v-model="content.WarehouseWorkNumber"
        :label="$t.warehouse.warehouseWorkNumber"
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(content.WarehouseWorkNumber)"
            v-if="content.WarehouseWorkNumber"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>
      <van-field
        v-model="content.WarehouseNumber"
        :label="$t.warehouse.warehouseNumber"
        label-class="number-label"
        readonly
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(content.WarehouseNumber)"
            v-if="content.WarehouseNumber"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="content.WarehouseCode"
        :label="$t.warehouse.warehouseCode"
        readonly
      />
      <van-field
        v-model="content.WarehouseName"
        :label="$t.warehouse.warehouseName"
        readonly
      />
      <van-field
        :value="content.StorageTime + ' ' + $t.warehouse.days"
        :label="$t.warehouse.storageTime"
        readonly
      />

      <template v-if="content.CostData">
        <div class="cost-title">{{ $t.warehouse.costTitle }}</div>
        <van-collapse v-model="active1" v-if="content.CostData.DetailList.length > 0">
          <van-collapse-item
            v-for="(item, index) in content.CostData.DetailList"
            :title="item.FinancialAccountNo"
            :name="index"
            :key="index"
          >
            <div class="collapse-item">
              {{ $t.warehouse.financialAccountNo }}：{{ item.FinancialAccountNo }}
            </div>
            <div class="collapse-item">
              {{ $t.warehouse.customerNumber }}：{{ item.CustomerNumber }}
            </div>
            <div class="collapse-item">
              {{ $t.warehouse.customerName }}：{{ item.CompanyNameSn }}
            </div>
            <div class="collapse-item">
              {{ $t.warehouse.billReferNo }}：{{ item.SupplierBillReferNo }}
            </div>
            <div class="collapse-currency">
              <div class="collapse-label">{{ $t.warehouse.totalPayable }}</div>
              <div
                class="collapse-amount"
                v-for="(currency, idx) in item.TotalAmountList"
                :key="idx"
              >
                {{ currency.CurrencySn }}：{{ currency.TotalAmount }}
              </div>
            </div>
            <div class="collapse-buttons">
              <van-button
                type="info"
                size="small"
                @click="toSupplierCostEntry(item.FinancialAccountNo)"
                >{{ $t.warehouse.viewCost }}</van-button
              >
              <van-button
                type="danger"
                size="small"
                @click="dialogShow(1, item.FinancialAccountNo)"
                >{{ $t.warehouse.deleteCost }}</van-button
              >
            </div>
          </van-collapse-item>
        </van-collapse>
        <div class="empty-text" v-else>{{ $t.meta.noData }}</div>
        <div class="subTotal" v-if="content.CostData.CostSubTotalList.length > 0">
          <div class="subTotal-label">{{ $t.warehouse.subTotal }}</div>
          <div
            class="subTotal-item"
            v-for="(item, index) in content.CostData.CostSubTotalList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>

        <div class="rate">
          <div class="rate-label">{{ $t.warehouse.rate }}</div>
          <div class="rate-item" v-for="(item, index) in content.RateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>

        <van-field
          style="border-top: 1px solid #ebedf0"
          v-model="content.CostTotalAmount"
          :label="$t.warehouse.totalAmount + ' ( ' + content.SettlementCurrency + ' ) '"
          readonly
        />
      </template>

      <template v-if="content.ReceivableData">
        <div class="sale-title">{{ $t.warehouse.sellTitle }}</div>
        <van-collapse
          v-model="active2"
          v-if="content.ReceivableData.DetailList.length > 0"
        >
          <van-collapse-item
            v-for="(item, index) in content.ReceivableData.DetailList"
            :title="item.InvoiceNo"
            :name="index"
            :key="index"
          >
            <div class="collapse-item">
              {{ $t.warehouse.invoiceNo }}：{{ item.InvoiceNo }}
            </div>
            <div class="collapse-item">
              {{ $t.warehouse.customerNumber }}：{{ item.CustomerNumber }}
            </div>
            <div class="collapse-item">
              {{ $t.warehouse.customerName }}：{{ item.CompanyNameSn }}
            </div>
            <div class="collapse-currency">
              <div class="collapse-label">{{ $t.warehouse.totalReceive }}</div>
              <div
                class="collapse-amount"
                v-for="(currency, idx) in item.TotalAmountList"
                :key="idx"
              >
                {{ currency.CurrencySn }}：{{ currency.TotalAmount }}
              </div>
            </div>
            <div class="collapse-buttons">
              <van-button
                type="info"
                size="small"
                @click="toBillsReceivable(item.InvoiceNo)"
                >{{ $t.warehouse.viewSell }}</van-button
              >
              <van-button
                type="danger"
                size="small"
                @click="dialogShow(2, item.InvoiceNo)"
                >{{ $t.warehouse.deleteSell }}</van-button
              >
            </div>
          </van-collapse-item>
        </van-collapse>
        <div class="empty-text" v-else>{{ $t.meta.noData }}</div>
        <div
          class="subTotal"
          v-if="content.ReceivableData.ReceivableSubTotalList.length > 0"
        >
          <div class="subTotal-label">{{ $t.warehouse.subTotal }}</div>
          <div
            class="subTotal-item"
            v-for="(item, index) in content.ReceivableData.ReceivableSubTotalList"
            :key="index"
          >
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.TotalAmount }}</div>
          </div>
        </div>

        <div class="rate">
          <div class="rate-label">{{ $t.warehouse.rate }}</div>
          <div class="rate-item" v-for="(item, index) in content.RateList" :key="index">
            <div class="item1">{{ item.CurrencySn }}</div>
            <div class="item2">{{ item.Rate }}</div>
          </div>
        </div>

        <van-field
          style="border-top: 1px solid #ebedf0"
          v-model="content.ReceivableTotalAmount"
          :label="
            $t.warehouse.receTotalAmount + ' ( ' + content.SettlementCurrency + ' ) '
          "
          readonly
        />

        <van-field
          v-model="content.ProfitsTotalAmount"
          :label="
            $t.warehouse.profitTotalAmount + ' ( ' + content.SettlementCurrency + ' ) '
          "
          readonly
        />
      </template>
    </van-form>
    <div v-else class="unload-text">{{ $t.warehouse.unloadText }}</div>

    <van-dialog
      :title="$t.warehouse.notice"
      width="90%"
      v-model="showDialog"
      @confirm="dialogConfirm"
      @cancel="dialogCancel"
      :confirm-button-text="$t.meta.confirm"
      :cancel-button-text="$t.meta.cancel"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <div style="margin: 20px; text-align: center">
        <div v-if="dialogType == 1">{{ $t.warehouse.deleteCheck1 }}</div>
        <div v-if="dialogType == 2">{{ $t.warehouse.deleteCheck2 }}</div>
      </div>
    </van-dialog>

    <div class="tool-bar" v-if="isLoaded">
      <van-button type="info" block @click="gotoPrint">{{ $t.meta.print }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Collapse,
  CollapseItem,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Collapse)
  .use(CollapseItem);

export default {
  name: "warehouseProfitAccounting",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      isLoaded: false,
      form: {
        PWB_Number: "",
        WB_Number: "",
      },
      searchText: "",
      content: {},
      active1: [],
      active2: [],
      //弹窗
      showDialog: false,
      dialogType: 1,
      dialogId: "",
    };
  },
  created() {
    var warehouseProfitAccounting = JSON.parse(
      localStorage.getItem("warehouseProfitAccounting")
    );
    if (warehouseProfitAccounting) {
      this.searchText = warehouseProfitAccounting.searchText;
      this.getList();
    }
  },
  methods: {
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
    toBillsReceivable(InvoiceNo) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "billsReceivable",
        name: "billsReceivable",
        query: [
          {
            name: "InvoiceNo",
            value: InvoiceNo,
          },
        ],
      });
    },
    toSupplierCostEntry(FinancialAccountNo) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "supplierCostEntry",
        name: "supplierCostEntry",
        query: [
          {
            name: "FinancialAccountNo",
            value: FinancialAccountNo,
          },
        ],
      });
    },
    dialogConfirm() {
      if (this.dialogType == 1) {
        this.deleteSupplierCostDetails(this.dialogId);
      }
      if (this.dialogType == 2) {
        this.deleteCollectionBill(this.dialogId);
      }
      this.showDialog = false;
    },
    dialogCancel() {
      this.dialogType = 1;
      this.dialogId = "";
      this.showDialog = false;
    },
    dialogShow(type, id) {
      this.dialogType = type;
      this.dialogId = id;
      this.showDialog = true;
    },
    getList() {
      this.$commonMethod.showLoading();
      var param = {
        WarehouseWorkNumber: this.searchText,
      };
      this.$api.storage
        .getWarehouseProfitAccounting(param)
        .then((res) => {
          this.content = res.data;
          this.isLoaded = true;
          var form = {
            searchText: this.searchText,
          };
          localStorage.setItem("warehouseProfitAccounting", JSON.stringify(form));
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteSupplierCostDetails(id) {
      var param = {
        FinancialAccountNo: id,
        UserId: this.UserId,
      };
      this.$api.logisticsManagement
        .deleteSupplierCostDetails(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.getList();
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    deleteCollectionBill(id) {
      var param = {
        InvoiceNo: id,
        UserId: this.UserId,
      };
      this.$api.logisticsManagement
        .deleteCollectionBill(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.getList();
        })
        .catch((error) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    gotoPrint() {
      var param = {
        WarehouseWorkNumber: this.searchText,
        FileType: 2,
        IsReturnBase64str: 1,
      };
      this.$commonEnv.commonAction(this.$commonEnv.actionType.routerPush, {
        isParams: true,
        path: "base64Print",
        name: "base64Print",
        query: [
          {
            name: "Api",
            value: "createWarehouseProfitAccountingFile",
          },
          {
            name: "Param",
            value: JSON.stringify(param),
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.warehouseProfitAccounting {
  ::v-deep .number-label {
    line-height: 33px;
  }
  ::v-deep .van-form {
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .van-cell::after {
      border: none !important;
    }
  }
  ::v-deep .van-collapse {
    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }
    .van-cell::after {
      border: none !important;
    }
    .van-collapse-item--border::after {
      border: none !important;
    }
  }
  ::v-deep .van-collapse::after {
    border: none !important;
  }
  ::v-deep .van-collapse-item__content {
    padding: 15px;
    background: transparent;
    border-bottom: 1px solid #ebedf0;
  }
  .unload-text {
    text-align: center;
    padding: 50px;
    font-size: 14px;
    color: #969799;
  }
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;
    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;
      .colItem1 {
        width: 100%;
        text-align: center;
        font-size: 14px;
        .van-search__action {
          width: 15%;
        }
        .van-search__content {
          padding: 0px;
          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
      }
    }
  }
  .cost-title {
    font-weight: bold;
    font-size: 14px;
    padding: 10px;
    background: #e4f6f0;
    color: #20b2aa;
    border: 2px solid #20b2aa;
  }
  .sale-title {
    font-weight: bold;
    font-size: 14px;
    padding: 10px;
    background: #e8f4ff;
    color: #1e90ff;
    border: 2px solid #87ceeb;
  }
  .empty-text {
    text-align: center;
    padding: 30px;
    font-size: 14px;
    color: #969799;
  }
  .collapse-item {
    font-size: 12px;
    margin-bottom: 5px;
  }
  .collapse-buttons {
    margin-top: 15px;
    text-align: center;
    .van-button:first-child {
      margin-right: 10px;
    }
  }
  .collapse-currency {
    font-size: 12px;
    .collapse-label {
      margin-bottom: 5px;
    }
    .collapse-amount {
      display: inline-block;
      width: 33.33%;
    }
  }
  .subTotal {
    padding: 15px;
    font-size: 12px;
    color: #646566;
    .subTotal-label {
      margin-bottom: 15px;
    }
    .subTotal-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      font-size: 12px;
      .item1 {
      }
      .item2 {
        padding-top: 15px;
      }
    }
  }
  .rate {
    border-top: 1px solid #ebedf0;
    padding: 15px;
    font-size: 12px;
    color: #646566;
    .rate-label {
      margin-bottom: 15px;
    }
    .rate-item {
      display: inline-block;
      width: 33.33%;
      text-align: center;
      font-size: 12px;
      .item1 {
      }
      .item2 {
        padding-top: 15px;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
